import styled, { css } from "styled-components";

export const CommonTdStyle = css`
  position: relative;
  padding: var(--Spacing-12, 1.2rem) var(--Spacing-8, 0.8rem);
  line-height: 1.8rem;
  border: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  vertical-align: top;
  word-break: break-all;
`;

export const CommonErrorStyles = css`
  background-color: ${({ theme }) => theme.color.neural.gray01};
  color: rgba(60, 71, 87, 0.5);

  a {
    color: rgba(60, 71, 87, 0.5);
  }

  span {
    color: rgba(60, 71, 87, 1);
  }
`;

export const ListTableBody = styled.tbody`
  background-color: #ffffff;
`;

export const ListTableTr = styled.tr<{
  isError: boolean;
}>`
  ${({ isError }) =>
    isError &&
    css`
      td {
        ${CommonErrorStyles}
      }
    `}
`;

export const ListTableId = styled.td`
  ${CommonTdStyle}
  width: 8.4rem;
  max-width: 8.8rem;
  min-width: 8.4rem;
  background: var(--Color-Common-Bg-Secondary, #f0f2f4);
`;

export const PublicationDate = styled.td`
  ${CommonTdStyle}
  width: 8.4rem;
  max-width: 10rem;
  min-width: 8.4rem;
`;

export const PublicationType = styled.td`
  ${CommonTdStyle}
  width: 8.4rem;
  max-width: 10rem;
  min-width: 8.4rem;
  word-break: break-word;
`;

export const TopicType = styled.td`
  ${CommonTdStyle}
  width: 8rem;
  max-width: 8.8rem;
  min-width: 8rem;
  word-break: break-word;
`;

export const JournalName = styled.td`
  ${CommonTdStyle}
  width: 9.6rem;
  min-width: 9.6rem;
  max-width: 12rem;
`;

export const Volume = styled.td`
  ${CommonTdStyle}
  width: 6.4rem;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  flex: 1 0 0;
`;

export const Issue = styled.td`
  ${CommonTdStyle}
  width: 7.2rem;
  max-width: 9.6rem;
  min-width: 7.2rem;
`;

export const AffiliationList = styled.td`
  ${CommonTdStyle}
  width: 10.4rem;
  max-width: 10.4rem;
  min-width: 12rem;
  word-break: break-word;

  &:hover {
    background: var(--Color-Common-Bg-Interactive-Primary-Subtle, #f0f9ff);
  }
`;

export const CtgListTableCompany = styled.td`
  ${CommonTdStyle}
  width: 10.4rem;
  cursor: pointer;
  position: relative;

  &:hover {
    background: var(--Color-Common-Bg-Interactive-Primary-Subtle, #f0f9ff);
  }
`;

export const ListTableEditor = styled.td`
  ${CommonTdStyle}
  width: 5.6rem;
  max-width: 7.2rem;
  min-width: 5.6rem;
  word-break: break-word;
`;

export const ListTableDate = styled.td`
  ${CommonTdStyle}
  width: 7.6rem;
  max-width: 8rem;
  min-width: 7.6rem;
  word-break: break-word;
`;

export const ListTableUnsuitable = styled.td<{
  isUnsuitable: boolean;
  isModalOpen?: boolean;
}>`
  ${CommonTdStyle}
  width: 8rem;
  background-color: ${({ isUnsuitable }) =>
    isUnsuitable ? "rgba(219, 15, 114, 0.1)" : ""};
  word-break: break-word;

  &:hover {
    background-color: var(--Color-Common-Bg-Warning-Subtle, #feece6);
  }

  &:active {
    background: var(--Color-Common-Bg-Danger-Subtle, #fde7e9);
  }

  ${({ isModalOpen }) =>
    isModalOpen &&
    css`
      background: var(--Color-Common-Bg-Warning-Subtle, #feece6);
    `}
`;

export const PressListTablePublishable = styled.td`
  ${CommonTdStyle}
  width: 8.8rem;
  text-align: center;
  cursor: pointer;
  padding: 0;
  vertical-align: middle;
`;

export const StatusTableData = styled.td<{ code: string }>`
  ${CommonTdStyle}
  width: 5.6rem;
  text-align: center;
  vertical-align: middle;
`;
